import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { Footer } from '@termly-web/common'

import { useAuth } from 'pkg/authentication'

import noop from 'utils/noop'

import PageTitle from 'components/PageTitle'

import BackButton from './BackButton'

import Styles from './styles.scss'


export default function BodyLayout(props) {
  const {
    children,
    className,
    right,
    showBackButton,
    handleBackButtonClick = noop,
    title,
    titleValues,
    top,
  } = props

  const { user } = useAuth()

  const _className = classnames(Styles.root, className)

  return (
    <div className={ _className }>
      <div className={ Styles.content }>
        <BackButton
          handleClick={ handleBackButtonClick }
          show={ showBackButton }
        />

        {
          renderPageTitle({
            title,
            titleValues,
          })
        }

        { renderTop(top) }

        <div className={ Styles.main }>
          <div className={ Styles.left }>
            { children }
          </div>
          { renderRight(right) }
        </div>
      </div>

      <div className={ Styles.footer }>
        <Footer
          isGuest={ user.guest }
        />
      </div>
    </div>
  )
}

function renderPageTitle({ title, titleValues }) {
  // There are rare cases where we don't actually want the normal title
  // rendering: DocumentPreviewLayout, for example, renders the page title
  // inside the `top` section.
  //
  if ( !title ) {
    return null
  }

  return (
    <PageTitle
      title={ title }
      values={ titleValues }
    />
  )
}
function renderTop(content) {
  if ( !content ) {
    return null
  }

  return (
    <div className={ Styles.top }>
      { content }
    </div>
  )
}

function renderRight(content) {
  if ( !content ) {
    return null
  }

  return (
    <div className={ Styles.right }>
      { content }
    </div>
  )
}

BodyLayout.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  handleBackButtonClick: BackButton.propTypes.handleClick,
  right: PropTypes.node,
  showBackButton: BackButton.propTypes.show,
  title: PageTitle.propTypes.title,
  titleValues: PageTitle.propTypes.values,
  top: PropTypes.node,
}
